import {z as zod} from "zod";

export type CanonicalWorkspaceCapabilityConfiguration = Record<string, never>;

export const canonicalWorkspaceCapabilityConfigurationValidator: zod.ZodType<CanonicalWorkspaceCapabilityConfiguration> = zod.strictObject({});
